import { Helmet } from "react-helmet-async";
import { OtpForm } from "../sections/auth/index.js";

export default function LoginPage(){
    return (
        <>
            <Helmet>
                <title>Login</title>
            </Helmet>
            <OtpForm />
        </>
    )
}